import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CategoryInterface, Offer } from '../../../services/exports/Interfaces';
import useMenu from '../../../hooks/menu/useMenu';
import { CompiledProduct } from '../../../providers/MenuProvider';
import WorkScheduleHelpers from '../../../services/helpers/WorkScheduleHelpers';
import { StoreInterface } from '../../../store/types';

export default function useAvailableFreeProducts(offer?: Offer): CompiledProduct[] {
  const { compileProduct, allCategories } = useMenu();
  const { cached_order } = useSelector((state: StoreInterface) => state.order);

  return useMemo(() => {
    if (!offer?.details?.free_products?.length) {
      return [];
    }

    return offer.details.free_products
      .map((id: number) => compileProduct(id))
      .filter((product): product is CompiledProduct => Boolean(product))
      .filter((product) => {
        const scheduledSources = (product.category_ids ?? [])
          .map((id: number) => allCategories.find((c) => c.id === id))
          .filter((c): c is CategoryInterface => Boolean(c?.schedule));

        if (scheduledSources.length === 0) {
          return true;
        }

        return scheduledSources.some((c) => WorkScheduleHelpers.isOpen(c.schedule, cached_order?.scheduled_for));
      });
  }, [offer?.details?.free_products, compileProduct, allCategories, cached_order?.scheduled_for]);
}
